<template lang="pug">
  v-expansion-panel
    v-expansion-panel-content(class="slim-header")
      template(v-slot:actions)
        div(v-if="merchantId" class='header-btn-area')
          p(style="text-align: right;")
            | <strong>Merchant ID</strong> {{ merchantId }}
          AppOutlinedButton(:buttonFunction="openPlansModal") MANAGE

      LenderListTile(
        slot="header"
        :logoSvg="logoSvg"
        :title="typeLabel"
        :subtitle="name"
        :merchantId="merchantId"
        :enrollmentLink="enrollmentLink"
        :active="active"
        :color="color"
      )
      v-divider

      template(v-if="!active && merchantId")
        p.pa-4 Your Merchant ID: {{ merchantId }} has been deactivated, please contact us using the Intercom Button or call us at (786) 375-9482

      template(v-if="active && isMounted")
        PlansSelectionModal(
        :isModalActive="isModalActive"
        :lenderName="nickName"
        :plans="allPlans"
        @close="closePlansModal"
        @save="savePlans"
      )

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AppOutlinedButton from 'Components/AppOutlinedButton.vue'
  import LenderListTile from '@/components/LenderListTile'
  import SaveButton from '@/components/SaveButton.vue'
  import PlansSelectionModal from 'Components/PlansSelectionModal.vue'
  import _isEqual from 'lodash/isEqual'
  import _orderBy from 'lodash/orderBy'
  import { parseLenderPlan } from '@/helpers/plansUtils'
  import { wellsfargo } from 'Helpers/lenders.js'
  const { logoSvg, typeLabel, name, nickName, color, description, enrollmentLink } = wellsfargo

  export default {
    name: 'wells-fargo-plan-expander',
    props: {
      merchantId: String,
      active: {
        type: Boolean,
        default: null
      },
    },
    components: {
      AppOutlinedButton,
      LenderListTile,
      SaveButton,
      PlansSelectionModal
    },
    data() {
      return {
        lenderId: "wellsfargo",
        logoSvg,
        name,
        nickName,
        typeLabel,
        color,
        description, 
        enrollmentLink,
        allPlans: [],
        selectedPlans: {},
        isModalActive: false,
        isMounted: false,
      }
    },
    computed: {
      ...mapGetters({
        activeWFPlans: 'wellsfargoPlans',
      }),
      plansStatus() {
        return this.plans
          .reduce((acc, p) => {
            if (p.enabled === undefined)
              acc[p.id] = true
            else
              acc[p.id] = p.enabled
            return acc
          }, {})
      },
    },
    async mounted() {
      await this.getAllPlans().then(plans => {
        this.allPlans = _orderBy(
          plans
            .filter(plan => plan.lenderProgramId === 10)
            .map(plan => {
              let p = parseLenderPlan(plan)
              if (this.activeWFPlans.some(plan => plan.planNumber === p.planNumber)) {
                p.isActive = true
              } else {
                p.isActive = false
              }
              return p
            }),
          ['planNumber'],
        )
      })
      this.isMounted = true
    },
    methods: {
      ...mapActions(['updatePlans', 'getAllPlans']),
      openPlansModal() {
        this.isModalActive = true
      },
      closePlansModal() {
        this.isModalActive = false
      },
      savePlans(selectedPlansMap, savedPlansMap) {
        const lenderPlanIds = Object.entries(selectedPlansMap)
          .filter(([key, val]) => val === true)
          .map(([key, val]) => this.allPlans.find(plan => plan.planNumber === key ).id )
        const data = {lender: this.lenderId, lenderPlanIds}
        this.updatePlans(data)
      },
    }
  }
</script>

<style scoped lang="scss">
  .slim-header >>> .expansion-panel__header{
    padding: 0;

    & .header__icon {
      margin-right: 10px;
    }
  }
  
  .max-height {
    max-height: 300px;
    overflow-y: scroll;
  }

  .header-btn-area {
    height: 100%;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
  }

</style>